import useApplication from '@platform-ui-common/hooks/contexts/useApplication.js';
import useProgram from '@platform-ui-common/hooks/contexts/useProgram.js';
import useTaxForms from '@platform-ui-common/hooks/useTaxForms.js';
import useApplicationConfig from '@platform-ui/application/hooks/useApplicationConfig.js';
import BankAccount from '@platform-ui/claim/pages/BankAccount/index.js';
import { makeRoute } from '@platform-ui/utilities/Routes.js';
import { getNextPage, getQuestion } from '@platform-ui/utilities/application/config.js';
import { SpecialQuestionKeys } from '@platform-ui/utilities/application/configs/standards/types.js';

export default function ApplicationBankAccount(): JSX.Element {
  const application = useApplication();
  const config = useApplicationConfig();
  const program = useProgram();
  const question = getQuestion(config, SpecialQuestionKeys.BankAccount);
  const { taxForms } = useTaxForms();
  const nextRoute = makeRoute(
    getNextPage(config, question, application.answers, program, taxForms),
    { applicationId: application.id },
  );

  return <BankAccount redirectTo={nextRoute} hideProgramUsageMessage />;
}
